import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core';
import { Refresh as RefreshIcon, Add as AddIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import { getUsers } from '../../data/Users/actions';

class User extends PureComponent {
    static propTypes = {
        users: PropTypes.object.isRequired,
        getUsers: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }

    refreshUsers = () => {
        const { getUsers } = this.props;
        this.setState({ loading: true });
        return getUsers()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `user/detail/${rowData.id}` });
    };
    navigateToAdd = () => {
        const { history } = this.props;
        return history.push({ pathname: 'user/add' });
    };

    renderActions = memoizeOne(profile => {
        const { history } = this.props;

        const userRight = profile.getIn(['user_rights', history.environment], []);
        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`generic.user.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshUsers
                }
            ]
        };
        if (profile.get('admin') || userRight.includes('userAdd')) {
            actions.toolbar.push({
                icon: AddIcon,
                tooltip: Translator.translate(`generic.user.table.globalAction.add.tooltip`),
                onClick: this.navigateToAdd
            });
        }
        if (profile.get('admin') || userRight.includes('userDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate(`general.showDetail`),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderData = memoizeOne(users => {
        let result = [];

        users.map((user, userId) => {
            result.push({
                id: parseInt(userId),
                email: user.get('email'),
                emailGoogle: user.get('emailGoogle'),
                lastname: user.get('lastname'),
                firstname: user.get('firstname'),
                city: user.get('city')
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        const { history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.emailGoogle'),
                name: 'emailGoogle'
            },
            {
                title: Translator.translate('general.table.column.lastname'),
                name: 'lastname',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('userDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.firstname'),
                name: 'firstname'
            },
            {
                title: Translator.translate('general.table.column.city'),
                name: 'city'
            }
        ];
    });

    render() {
        const { loading } = this.state;
        const { users, profile, history } = this.props;

        return (
            <FHETable
                idTable="userList"
                columns={this.renderColumns(profile)}
                data={this.renderData(users)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`generic.user.table.title`)}
                emptyDataSourceMessage={Translator.translate(`generic.user.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    return {
        profile: state.data.user,
        users: state.environments[history.environment].data.Users.get('list')
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { getUsers }), dispatch)
    )(withTheme(User))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/index.js